import { StyleSheet } from 'react-native';
import {moderateScale} from "../../../../tools/Scaling";

export default StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 5,
  },

  itemContainer: {
    position: 'absolute',
    zIndex: 7,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  dimmer: {
    zIndex: 5,
  },

  activityIndicator: {
    width: moderateScale(30),
    height: moderateScale(30),
    alignSelf: 'center',
  },

  closeIcon: {
    fontSize:  moderateScale(33),
    lineHeight:  moderateScale(32),
  },

  menuIcon: {
    fontSize:  moderateScale(31),
    lineHeight: moderateScale(30),
  },
});
